/**
 * @module NPMloader/Constants
 */

import { TCheckoutEnvironment, TCheckoutMajorVersion, TModule } from './types';

export const VERSION_DEV = 'dev';
export const VERSION_1 = '1';
export const VERSION_2 = '2';

export const ENVIRONMENT_DEV = 'dev';
export const ENVIRONMENT_TEST = 'test';
export const ENVIRONMENT_PROD = 'prod';
export const ENVIRONMENT_PREFERRED = ENVIRONMENT_PROD;

export const ENVIRONMENT_DEV_CDN_URL = 'https://localhost:8787/sdk/';
export const ENVIRONMENT_TEST_CDN_URL = 'https://checkout.comgate-test.cz/sdk/';
export const ENVIRONMENT_PROD_CDN_URL = 'https://checkout.comgate.cz/sdk/';
export const ENVIRONMENT_DEV_API_URL = 'https://payments-web/';
export const ENVIRONMENT_TEST_API_URL = 'https://payments.comgate-test.cz/';
export const ENVIRONMENT_PROD_API_URL = 'https://payments.comgate.cz/';

export const TIMEOUT_LOAD_DEFAULT = 10000;
export const TIMEOUT_LOAD_MIN = 500;
export const TIMEOUT_LOAD_MAX = 30000;

export const TIMEOUT_FETCH_DEFAULT = 5000;
export const TIMEOUT_FETCH_MIN = 500;
export const TIMEOUT_FETCH_MAX = 15000;

export const checkoutEnvironments: TCheckoutEnvironment[] = [ENVIRONMENT_DEV, ENVIRONMENT_TEST, ENVIRONMENT_PROD] as const;

export const VERSION_PREFERRED = VERSION_2;

export const checkoutVersions: TCheckoutMajorVersion[] = [VERSION_1, VERSION_2, VERSION_DEV] as const;

export const checkoutIdRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i; // UUID v4
export const versionRegex = new RegExp(`^([12]\\.[0-9]+\\.[0-9]+|${checkoutVersions.join('|')})$`, 'i');
export const semverRegex = new RegExp(`^([12]\\.[0-9]+\\.[0-9]+)$`, 'i');
// Export const baseUrlRegex = new RegExp(`^https?://[a-z0-9_.-]+(?::[0-9]+)?/(?:[a-z0-9_.-]+/)?$`, 'i');

// Export const checkoutBaseUrl = 'https://checkout.comgate.cz/sdk/'; // PROD
// Export const checkoutBaseUrl = 'https://localhost:8787/sdk/'; // DEV

export const MODULE_LOADER = 'loader';
export const MODULE_CORE = 'core';
export const FILE_MODULE_CORE = 'checkout-core.min.js';

export const moduleCore: TModule = {
    boundName: 'comgateCheckoutCore',
    name: MODULE_CORE,
    events: {
        ready: 'ComgateCheckoutCoreLoaded',
    },
    mountPoint: ['comgate', 'checkout', 'core'],
    file: FILE_MODULE_CORE,
};

export const MODULE_APPLEPAY = 'applepay';
export const FILE_MODULE_APPLEPAY = 'checkout-apple-pay.min.js';

export const moduleApplePay: TModule = {
    boundName: 'comgateCheckoutApplePay',
    name: MODULE_APPLEPAY,
    events: {
        ready: 'ComgateCheckoutApplePayLoaded',
    },
    mountPoint: ['comgate', 'checkout', 'applepay'],
    file: FILE_MODULE_APPLEPAY,
};

export const MODULE_GOOGLEPAY = 'googlepay';
export const FILE_MODULE_GOOGLEPAY = 'checkout-google-pay.min.js';

export const moduleGooglePay: TModule = {
    boundName: 'comgateCheckoutGooglePay',
    name: MODULE_GOOGLEPAY,
    events: {
        ready: 'ComgateCheckoutGooglePayLoaded',
    },
    mountPoint: ['comgate', 'checkout', 'googlepay'],
    file: FILE_MODULE_GOOGLEPAY,
};

export const EVENT_MODULES_LOADED = 'comgate-checkout-js-module-loaded';
// Export const EVENT_MODULES_PRELOADED = 'comgate-checkout-js-module-preloaded';

export const MODULE_LOAD_SUCCESSFULLY = 'true';
export const MODULE_LOAD_FAILED = 'false';

export const outerModuleList = [MODULE_CORE, MODULE_APPLEPAY, MODULE_GOOGLEPAY] as const;
export const moduleList = [MODULE_CORE, MODULE_APPLEPAY, MODULE_GOOGLEPAY, MODULE_LOADER] as const;
